"use strict";

import { Box, HorizontalAutoScroller } from '@autoguru/overdrive';
import * as styles from '~/src/components/ManageAllFleetVehicles/ManageAllFleetVehicles.css';
import { ManageAllFleetVehiclesCarousel } from '~/src/components/ManageAllFleetVehicles/ManageAllFleetVehiclesCarousel';
import { carouselDesktopContent, carouselMobileContent, slideDuration } from '~/src/components/ManageAllFleetVehicles/contentManageAll';
import { jsx as _jsx } from "react/jsx-runtime";
export const ManageAllFleetVehicles = ({
  isDesktop
}) => {
  return /*#__PURE__*/_jsx(Box, {
    className: styles.container,
    paddingY: "8",
    children: /*#__PURE__*/_jsx(Box, {
      paddingX: isDesktop ? '9' : '5',
      style: {
        maxWidth: '1200px',
        margin: '0 auto'
      },
      children: /*#__PURE__*/_jsx(HorizontalAutoScroller, {
        noControls: true,
        durationSeconds: slideDuration,
        sliderProgressColour: "primary",
        space: "5",
        columnWidth: "full",
        children: isDesktop ? carouselDesktopContent.map(item => /*#__PURE__*/_jsx(ManageAllFleetVehiclesCarousel, {
          content: item,
          isDesktop: true
        }, item.title)) : carouselMobileContent.map(item => /*#__PURE__*/_jsx(ManageAllFleetVehiclesCarousel, {
          content: item,
          isDesktop: false
        }, item.title))
      })
    })
  });
};
export default ManageAllFleetVehicles;